<template>
    <div>
      <!-- 面包屑导航 -->
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>积分管理</el-breadcrumb-item>
        <el-breadcrumb-item>积分明细</el-breadcrumb-item>
      </el-breadcrumb>
      <!-- 搜索筛选 -->
      <el-form :inline="true" :model="formInline" class="user-search">
        <el-form-item label="用户名">
          <el-input size="small" v-model="formInline.userName" clearable placeholder="请输入用户名"></el-input>
        </el-form-item>
        <el-form-item label="手机号">
          <el-input size="small" v-model="formInline.phone" clearable placeholder="请输入手机号"></el-input>
        </el-form-item>
        <el-form-item label="订单编号">
          <el-input size="small" v-model="formInline.orderNum" clearable placeholder="请输入订单编号"></el-input>
        </el-form-item>
        <el-form-item label="积分归属">
          <el-select
            size="small"
            clearable
            filterable
            v-model="formInline.integralDeduction"
            placeholder="请选择积分归属"
          >
            <el-option
              v-for="item in integralDeductionOptions"
              :key="item.id + '-smlxkey'"
              :label="item.key"
              :value="item.val"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-date-picker
          size="small"
          v-model="dateRange"
          type="daterange"
          @change="dateChange"
          value-format="yyyy-MM-dd"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期">
        </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
          <!-- <el-button size="small" type="primary" icon="el-icon-plus" @click="handleEdit()">添加</el-button> -->
        </el-form-item>
      </el-form>
      <el-row style="margin-bottom: 10px">
        <el-button size="small" type="info" plain icon="el-icon-upload2" @click="handleExport">导出</el-button>
      </el-row>
      <!--列表 用户名称，手机号，订单号，积分明细（加减多少），时间-->
      <el-table size="small"  @selection-change="selectChange" :data="listData" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;">
        <el-table-column align="center" type="selection" width="50">
        </el-table-column>
        <el-table-column prop="userName" label="用户名称">
        </el-table-column>
        <el-table-column prop="phone" label="手机号">
        </el-table-column>
        <el-table-column prop="orderNum" label="订单编号">
        </el-table-column>
        <el-table-column prop="deductIntegral" label="积分明细">
        </el-table-column>
        <el-table-column prop="integralDeduction" label="积分归属">
          <template slot-scope="scope">
            {{ filterFun(scope.row.integralDeduction) }}
          </template>
        </el-table-column>
        <el-table-column prop="createDate" label="消费时间">
          <template slot-scope="scope">
            <div>{{scope.row.createDate|timestampToTime}}</div>
          </template>
        </el-table-column>
        <!-- <el-table-column sortable prop="status" label="状态">
          <template slot-scope="scope">
            <el-tag :type="scope.row.status==0?'danger':'success'">{{activeText[scope.row.status*1]}}</el-tag>
          </template>
        </el-table-column> -->
        <!-- <el-table-column align="center" label="操作" >
          <template slot-scope="scope">
            <el-button size="mini" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
            <el-button size="mini" type="danger" @click="deleteUser(scope.$index, scope.row)">删除</el-button>
          </template>
        </el-table-column> -->
      </el-table>
      <!-- 分页组件 -->
      <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
    </div>
  </template>

  <script>
  import { getAllFalow } from '@/api/basisMG'
  import Pagination from '../../components/Pagination'
  import {exportIntegralFlow} from "../../api/system";
  import exportFile from '@/utils/exportFile'
  import {Loading} from "element-ui";
  export default {
    data() {
      return {
        nshow: true, //switch开启
        fshow: false, //switch关闭
        loading: false, //是显示加载
        editFormVisible: false, //控制编辑页面显示与隐藏
        title: '添加',
        activeText:['禁用','启用'],
        dateRange:null,
        editForm: {
          status:'1',
          cnName:''
        },
        // rules表单验证
        rules: {
          cnName: [
            { required: true, message: '请输入类型名称', trigger: 'blur' }
          ],
        },
        formInline: {
          pageNum: 1,
          pageSize: 10,
        },
        // 删除部门
        seletedata: {
          ids: '',
          token: localStorage.getItem('logintoken')
        },
        userparm: [], //搜索权限
        listData: [], //用户数据
        // 分页参数
        pageparm: {
          currentPage: 1,
          pageSize: 10,
          total: 10
        },
        integralDeductionOptions:[
          {
            key:'千尚',
            val:0,
            id:1
          },
          {
            key:'国大',
            val:1,
            id:2
          }
        ],
        ids:''
      }
    },
    // 注册组件
    components: {
      Pagination
    },
    /**
     * 数据发生改变
     */

    /**
     * 创建完毕
     */
    created() {
      this.getdata(this.formInline)
    },

    /**
     * 里面的方法只有被调用才会执行
     */
    methods: {
      // 获取公司列表
      getdata(parameter) {
        this.loading = true
        getAllFalow(parameter)
          .then(res => {
            this.loading = false
            if (res.code != 200) {
              this.$message({
                type: 'info',
                message: res.msg
              })
            } else {
              this.listData = res.rows
              // 分页赋值
              this.pageparm.currentPage = this.formInline.pageNum
              this.pageparm.pageSize = this.formInline.pageSize
              this.pageparm.total = res.total
            }
          })
          .catch(err => {
            this.loading = false
            this.$message.error('加载失败，请稍后再试！')
          })
      },
      // 分页插件事件
      callFather(parm) {
        this.formInline.pageNum = parm.currentPage
        this.formInline.pageSize = parm.pageSize
        this.getdata(this.formInline)
      },
      // 搜索事件
      search() {
        this.formInline.pageNum=1
        this.getdata(this.formInline)
      },
      selectChange(selection){
        // if(selection.length>0){
        //   this.isSynchronization = false
        // }else{
        //   this.isSynchronization = true
        // }
        let ids;
        ids = selection.map(item => item.id)
        this.ids = ids.join()
        console.log(this.ids);
      },

      dateChange(v){
        console.log(v);
        if(!!v){
          this.formInline.beginCreatDate	= v[0]
          this.formInline.endCreatDate	= v[1]
        }else{
          this.formInline.beginCreatDate	= ''
          this.formInline.endCreatDate	= ''
        }
      },
      // 关闭编辑、增加弹出框
      closeDialog() {
        this.editFormVisible = false
      },
      filterFun(v) {
        let val;
        v == 0 ? val='千尚':val ='国大'
        return val
      },
      /** 导出按钮操作 */
      handleExport() {
        // this.download('system/goods/export', {
        //   ...this.queryParams
        // }, `goods_${new Date().getTime()}.xlsx`)
        let downloadLoadingInstance;
        downloadLoadingInstance = Loading.service({
          text: "正在下载数据，请稍候",
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)",
        })
        //极光
        exportIntegralFlow({ ...this.formInline,ids: this.ids}).then(res => {
          exportFile.getExcel(res, `productList_${new Date().getTime()}`)
          downloadLoadingInstance.close()
        }).catch(() => {
          downloadLoadingInstance.close()
        })
      },
    }
  }
  </script>

  <style scoped>
  .user-search {
    margin-top: 20px;
  }
  .userRole {
    width: 100%;
  }
  </style>




// WEBPACK FOOTER //
// src/views/integralManage/integralDetail.vue